import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const PointBottomLeftToTopRightFill48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M15.9995 28.001C18.9462 28.001 21.3335 30.39 21.3335 33.334C21.3335 36.278 18.9462 38.667 15.9995 38.667C13.053 38.6668 10.6665 36.2779 10.6665 33.334C10.6665 30.3901 13.053 28.0012 15.9995 28.001ZM27.0835 12.001V14.2656H17.7056C16.5202 14.2656 15.9255 15.702 16.7642 16.542L28.0581 27.8389C30.5781 30.3588 28.7945 34.6669 25.2319 34.667H23.6167V32.4023H26.1987C27.3866 32.4022 27.9824 30.9659 27.1411 30.126L15.8452 18.8291C13.3239 16.3078 15.108 12.001 18.6733 12.001H27.0835ZM33.3335 9.33398C35.5427 9.33416 37.3335 11.1261 37.3335 13.334C37.3335 15.5419 35.5427 17.3338 33.3335 17.334C31.1242 17.334 29.3335 15.542 29.3335 13.334C29.3335 11.126 31.1242 9.33398 33.3335 9.33398Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
